import React from 'react';
//import PropTypes from 'prop-types';
//import styled from 'styled-components';
import ReactS3Uploader from 'react-s3-uploader';
import uuid from 'react-uuid';
import Button from '../Buttons/Button';
import config from '../../../core/config';
import * as apiServices from '../../../services/apiServices';

const FileUploader = (props) => {
  let awsUrl = '';
  let contentType = '';

  // Create a reference to the hidden file input element
  const hiddenFileInput = React.useRef(null);
  
  // Programatically click the hidden file input element
  // when the Button component is clicked
  const handleClick = event => {
    hiddenFileInput.current.click();
  };

  const getSignedUrl = async (file, callback) => {
    const bucket = config.aws.storage.buckets[props.fileType];
    const fileKey = `public/${uuid()}`;

    awsUrl = `https://${bucket}.s3.amazonaws.com/${fileKey}`;
    contentType = file.type;

    const response = await apiServices.getPresignedUrl({
      bucket: bucket,
      contentType: contentType,
      key: fileKey,
      metadata: props.metadata,
      region: config.aws.region,
    });

    callback({
      signedUrl: response.url
    });
  };

  const getRequestHeaders = () => {
    const headers = {
      'Cache-Control': 'max-age=31536000',
      'x-amz-server-side-encryption': 'AES256',
    };

    if (contentType) {
      headers['Content-Type'] = contentType;
    }

    if (props.metadata) {
      Object.keys(props.metadata).forEach((metadataKey) => {
        headers[`x-amz-meta-${metadataKey}`] = props.metadata[metadataKey];
      });
    }

    return headers;
  }

  const onFinish = () => {
    if (props.onFinish) {
      props.onFinish({ awsUrl });
    }
  }

  /* onError={this.onUploadError} */
  // contentDisposition="attachment" // < backend does this?
  /* uploadRequestHeaders={{ 'x-amz-acl': 'public-read' }} */ // this is the default
  // cache control?

  return (
    <>
      <Button
        fullWidth={props.fullWidth}
        onClick={handleClick}
        variant={props.variant}
      >
        {props.buttonText}
      </Button>
      <ReactS3Uploader
        accept={props.accept}
        getSignedUrl={getSignedUrl}
        inputRef={hiddenFileInput}
        onFinish={onFinish}
        onProgress={props.onProgress}
        uploadRequestHeaders={getRequestHeaders()}
        style={{display: 'none'}}
      />
    </>
  );
}

export default FileUploader;
